/**
 * Subdomain Detection Utility
 * Detects tenant-specific subdomains for multi-tenant routing
 */

export function detectSubdomain(): string | null {
  if (typeof window === 'undefined') return null;
  
  const hostname = window.location.hostname;
  
  // Handle localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }
  
  // Split hostname by dots
  const parts = hostname.split('.');
  
  // Check for subdomain (anything before the main domain)
  // Assuming pattern: {subdomain}.{domain}.{tld}
  if (parts.length >= 3) {
    const subdomain = parts[0];
    
    // Skip common subdomains
    const reserved = ['www', 'api', 'admin', 'app', 'portal', 'dashboard', 'mcp'];
    if (reserved.includes(subdomain.toLowerCase())) {
      return null;
    }
    
    return subdomain;
  }
  
  return null;
}

export function extractTenantFromSubdomain(): string | null {
  const subdomain = detectSubdomain();
  return subdomain;
}
